import React from 'react';
import { motion } from 'framer-motion';
import { bonos } from '../data/content';
export function BonosSection() {
  return <section className="w-full bg-ink px-5 py-12 sm:py-20" data-id="element-26" data-mp="185xjh68yb20v">
      <div className="mx-auto max-w-5xl" data-id="element-27" data-mp="13dnx2071ok3c">
        <div className="mx-auto max-w-2xl text-center" data-id="element-28" data-mp="13cmjnp2k3lig">
          <h2 className="font-display text-2xl font-bold leading-tight text-surface sm:text-4xl" data-id="element-29" data-mp="yf2uvv88fqc9">
            🎁 4 Bonos <span className="text-pink-light" data-id="element-30" data-mp="tg9ik64om5do">incluidos</span>
          </h2>
          <p className="mt-3 text-sm text-surface/75 sm:text-base" data-id="element-31" data-mp="ogn3dr5amf28">
            Sin costo adicional. Incluidos en tu acceso de hoy.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-32" data-mp="kfldw216hhdg">
          {bonos.map((bono, i) => <motion.article key={bono.badge} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: i % 2 * 0.08
        }} className="flex flex-col rounded-2xl border border-surface/10 bg-ink-card p-5 sm:p-6" data-id="element-33" data-mp="fha2vnz5d0tn" data-mpi={i}>
              <img src={bono.image} alt={`Mockup del ${bono.badge.toLowerCase()}: ${bono.title}`} width="800" height="800" loading="lazy" decoding="async" className="block aspect-square w-full rounded-media object-cover" data-id="element-34" data-mp="vw2d8udgbb9w" />
              <span className="mt-5 w-fit rounded-md bg-blush px-2.5 py-1 text-[11px] font-bold tracking-wide text-pink" data-id="element-35" data-mp="mvx6mmg30gws">
                {bono.badge}
              </span>
              <h3 className="mt-3 text-base font-bold leading-snug text-surface sm:text-lg" data-id="element-36" data-mp="1ejp9ua5wqxm0">
                {bono.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-surface/75" data-id="element-37" data-mp="15soxbgxydyav">
                {bono.description}
              </p>
              <div className="mt-5 flex items-center justify-between gap-3" data-id="element-38" data-mp="1thznk4hogaar">
                <span className="text-sm text-line line-through" data-id="element-39" data-mp="1y8pwfrpbava7">{bono.value}</span>
                <span className="shrink-0 rounded-full bg-pink px-3 py-1 text-xs font-bold text-surface" data-id="element-40" data-mp="284yezzgjb4ph">
                  INCLUIDO HOY
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}